// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.server-page {
    --hmi-bg: #F5F7FB;
    --hmi-card: #FFFFFF;
    --hmi-accent: #2563EB;
    --hmi-accent-ink: #FFFFFF;
    --hmi-text: #0F172A;
    --hmi-muted: #475569;
    --hmi-hover: #EEF4FF;
    --hmi-border: #E2E8F0;
    --hmi-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 10px 28px rgba(15, 23, 42, 0.05);
    --hmi-row: #F8FAFC;
    --hmi-good: #047857;
    --hmi-good-bg: #ECFDF5;
    --hmi-warn: #B45309;
    --hmi-warn-bg: #FFFBEB;
    --hmi-danger: #B91C1C;
    --hmi-danger-bg: #FEF2F2;
    --hmi-input: #FFFFFF;
    color-scheme: light;
    box-sizing: border-box;
    min-height: calc(100vh - 64px);
    padding: 28px 32px 40px;
    background: var(--hmi-bg);
    color: var(--hmi-text);
    font-family: "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.server-page[data-theme="dark"] {
    --hmi-bg: #0B1220;
    --hmi-card: #172033;
    --hmi-accent: #38BDF8;
    --hmi-accent-ink: #082033;
    --hmi-text: #F1F5F9;
    --hmi-muted: #CBD5E1;
    --hmi-hover: #1E293B;
    --hmi-border: #334155;
    --hmi-shadow: 0 1px 2px rgba(0, 0, 0, 0.28), 0 12px 32px rgba(0, 0, 0, 0.22);
    --hmi-row: #121A2B;
    --hmi-good: #34D399;
    --hmi-good-bg: rgba(52, 211, 153, 0.12);
    --hmi-warn: #FBBF24;
    --hmi-warn-bg: rgba(251, 191, 36, 0.12);
    --hmi-danger: #FCA5A5;
    --hmi-danger-bg: rgba(248, 113, 113, 0.12);
    --hmi-input: #0F172A;
    color-scheme: dark;
}

.server-page--embedded {
    min-height: 0;
    padding: 0;
    overflow: visible;
    background: transparent;
    font-family: inherit;
}

.server-page--embedded .server-page__card {
    margin: 16px 18px;
    box-shadow: none;
}

.server-page *,
.server-page *::before,
.server-page *::after {
    box-sizing: border-box;
}

.server-page h1,
.server-page h2,
.server-page h3,
.server-page p {
    margin: 0;
    color: var(--hmi-text);
}

.server-page__top {
    margin-bottom: 22px;
}

.server-page__eyebrow {
    margin-bottom: 6px;
    color: var(--hmi-accent);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.server-page h1 {
    font-size: 32px;
    line-height: 1.15;
    font-weight: 700;
    letter-spacing: -0.03em;
}

.server-page__subtitle {
    margin-top: 6px;
    color: var(--hmi-muted);
    font-size: 15px;
}

.server-page__card {
    margin-bottom: 18px;
    border: 1px solid var(--hmi-border);
    border-radius: 18px;
    background: var(--hmi-card);
    box-shadow: var(--hmi-shadow);
}

.server-page__card-head {
    padding: 18px 18px 0;
}

.server-page__card-head h2,
.server-page__item h3 {
    font-size: 18px;
    letter-spacing: -0.02em;
}

.server-page__card-head p {
    margin-top: 4px;
    color: var(--hmi-muted);
    font-size: 13px;
}

.server-page__form,
.server-page__banner,
.server-page__test,
.server-page__empty {
    margin: 16px 18px;
}

.server-page__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
}

.server-page__field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.server-page__field--wide {
    grid-column: 1 / -1;
}

.server-page__field label {
    color: var(--hmi-muted);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.server-page__field input,
.server-page__field select,
.server-page__field textarea {
    width: 100%;
    max-width: none;
    margin: 0;
    padding: 10px 12px;
    border: 1px solid var(--hmi-border);
    border-radius: 10px;
    background: var(--hmi-input);
    color: var(--hmi-text);
    font: inherit;
    font-size: 14px;
}

.server-page__field input,
.server-page__field select {
    height: 40px;
    padding-top: 0;
    padding-bottom: 0;
}

.server-page__field textarea {
    min-height: 96px;
    resize: vertical;
}

.server-page__field input:focus-visible,
.server-page__field select:focus-visible,
.server-page__field textarea:focus-visible,
.server-page__button:focus-visible {
    outline: 2px solid var(--hmi-accent);
    outline-offset: 2px;
}

.server-page__actions,
.server-page__test {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
}

.server-page__test {
    padding-bottom: 18px;
}

.server-page__button {
    min-height: 40px;
    margin: 0;
    padding: 10px 16px;
    border: 1px solid var(--hmi-accent);
    border-radius: 12px;
    background: var(--hmi-card);
    color: var(--hmi-accent);
    font: inherit;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: var(--hmi-shadow);
}

.server-page__button--primary {
    background: var(--hmi-accent);
    color: var(--hmi-accent-ink);
}

.server-page__button:hover,
.server-page__button:focus-visible {
    background: var(--hmi-accent);
    color: var(--hmi-accent-ink);
}

.server-page__button:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.server-page__banner {
    flex: 1 1 280px;
    padding: 12px 14px;
    border-radius: 12px;
    border: 1px solid var(--hmi-border);
    background: var(--hmi-row);
    color: var(--hmi-text);
    font-size: 14px;
    font-weight: 600;
}

.server-page__banner.is-success {
    color: var(--hmi-good);
    background: var(--hmi-good-bg);
    border-color: transparent;
}

.server-page__banner.is-error {
    color: var(--hmi-danger);
    background: var(--hmi-danger-bg);
    border-color: transparent;
}

.server-page__banner.is-pending {
    color: var(--hmi-warn);
    background: var(--hmi-warn-bg);
    border-color: transparent;
}

.server-page__empty {
    padding: 8px 0 28px;
    color: var(--hmi-muted);
    text-align: center;
    font-size: 14px;
}

.server-page__list {
    list-style: none;
    margin: 16px 0 0;
    padding: 0;
}

.server-page__item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 18px;
    padding: 16px 18px;
    border-top: 1px solid var(--hmi-border);
}

.server-page__item:hover {
    background: var(--hmi-hover);
}

.server-page__endpoint {
    margin-top: 4px;
    color: var(--hmi-text);
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: 13px;
}

.server-page__description {
    max-width: 460px;
    color: var(--hmi-muted);
    font-size: 14px;
    line-height: 1.45;
    text-align: right;
}

.server-page__edit { width: 100%; }
.server-page__summary { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; }
.server-page__state { padding: 4px 9px; border-radius: 999px; background: rgba(4, 120, 87, .12); color: #047857; font-size: 12px; font-weight: 700; }
.server-page__state.is-archived { background: var(--hmi-danger-bg); color: var(--hmi-danger); }
.server-page__expiry { color: var(--hmi-muted); font-size: 13px; white-space: nowrap; }
.server-page__row-actions { display: flex; gap: 8px; }
.server-page__row-actions .server-page__button { width: auto; padding: 8px 12px; }
.server-page__button--danger { border-color: var(--hmi-danger); color: var(--hmi-danger); }
.server-page__field small { color: var(--hmi-muted); font-size: 12px; }
.server-page__table-wrap { width: 100%; margin-top: 16px; overflow-x: auto; }
.server-page__archive-table { width: 100%; border-collapse: collapse; color: var(--hmi-text); }
.server-page__archive-table th,
.server-page__archive-table td { padding: 12px 14px; border-bottom: 1px solid var(--hmi-border); text-align: left; vertical-align: middle; }
.server-page__archive-table th { background: var(--hmi-hover); color: var(--hmi-muted); font-size: 12px; font-weight: 700; text-transform: uppercase; }
.server-page__archive-table .server-page__endpoint { margin: 0; }
.server-page__servers-table { min-width: 950px; font-size: 13px; }
.server-page__archive-table tbody tr:nth-child(even) { background: var(--hmi-row); }
.server-page__archive-table tbody tr:hover { background: var(--hmi-hover); }
.server-page__health, .server-page__last-error { display: flex; flex-direction: column; align-items: flex-start; gap: 5px; }
.server-page__connection { display: inline-flex; align-items: center; gap: 6px; padding: 4px 9px; border-radius: 999px; font-size: 12px; font-weight: 700; white-space: nowrap; }
.server-page__connection::before { content: ""; width: 7px; height: 7px; border-radius: 50%; background: currentColor; }
.server-page__connection.is-online { color: var(--hmi-good); background: var(--hmi-good-bg); }
.server-page__connection.is-offline { color: var(--hmi-danger); background: var(--hmi-danger-bg); }
.server-page__connection.is-unknown { color: var(--hmi-warn); background: var(--hmi-warn-bg); }
.server-page__health small, .server-page__last-error small, .server-page__no-error, .server-page__table-description { color: var(--hmi-muted); font-size: 11px; }
.server-page__table-description { display: block; margin-top: 4px; max-width: 180px; overflow-wrap: anywhere; }
.server-page__last-error { min-width: 200px; max-width: 370px; font-size: 12px; overflow-wrap: anywhere; }
.server-page__last-error code { color: var(--hmi-danger); font-size: 11px; }

@media (max-width: 900px) {
    .server-page__grid,
    .server-page__item {
        grid-template-columns: 1fr;
        flex-direction: column;
    }

    .server-page__description {
        max-width: none;
        text-align: left;
    }

    .server-page__expiry { white-space: normal; }
}

@media (max-width: 800px) {
    .server-page {
        padding: 18px 14px 28px;
    }

    .server-page--embedded {
        padding: 0;
    }

    .server-page h1 {
        font-size: 26px;
    }

    .server-page__button {
        width: 100%;
    }
}

@media (prefers-reduced-motion: reduce) {
    .server-page__button {
        transition: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AddServer.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,kFAAkF;IAClF,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,wBAAwB;IACxB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,yBAAyB;IACzB,sBAAsB;IACtB,oEAAoE;AACxE;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,4EAA4E;IAC5E,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;IACnB,uCAAuC;IACvC,qBAAqB;IACrB,0CAA0C;IAC1C,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;;;IAII,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;;;IAII,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;;IAGI,WAAW;IACX,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,mCAAmC;IACnC,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;;;IAII,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;;IAEI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;IACnC,0BAA0B;IAC1B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qEAAqE;IACrE,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,qBAAqB,WAAW,EAAE;AAClC,wBAAwB,aAAa,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,SAAS,EAAE;AAC3G,sBAAsB,gBAAgB,EAAE,oBAAoB,EAAE,iCAAiC,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACpJ,kCAAkC,gCAAgC,EAAE,wBAAwB,EAAE;AAC9F,uBAAuB,uBAAuB,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACtF,4BAA4B,aAAa,EAAE,QAAQ,EAAE;AACrD,iDAAiD,WAAW,EAAE,iBAAiB,EAAE;AACjF,+BAA+B,+BAA+B,EAAE,wBAAwB,EAAE;AAC1F,4BAA4B,uBAAuB,EAAE,eAAe,EAAE;AACtE,2BAA2B,WAAW,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC5E,8BAA8B,WAAW,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AAC9F;iCACiC,kBAAkB,EAAE,0CAA0C,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAC3I,iCAAiC,4BAA4B,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;AACtJ,qDAAqD,SAAS,EAAE;AAChE,8BAA8B,gBAAgB,EAAE,eAAe,EAAE;AACjE,uDAAuD,0BAA0B,EAAE;AACnF,6CAA6C,4BAA4B,EAAE;AAC3E,iDAAiD,aAAa,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;AAC3H,2BAA2B,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAChL,mCAAmC,WAAW,EAAE,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AACvH,qCAAqC,sBAAsB,EAAE,8BAA8B,EAAE;AAC7F,sCAAsC,wBAAwB,EAAE,gCAAgC,EAAE;AAClG,sCAAsC,sBAAsB,EAAE,8BAA8B,EAAE;AAC9F,sHAAsH,uBAAuB,EAAE,eAAe,EAAE;AAChK,kCAAkC,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC9G,2BAA2B,gBAAgB,EAAE,gBAAgB,EAAE,eAAe,EAAE,uBAAuB,EAAE;AACzG,gCAAgC,wBAAwB,EAAE,eAAe,EAAE;;AAE3E;IACI;;QAEI,0BAA0B;QAC1B,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA,uBAAuB,mBAAmB,EAAE;AAChD;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".server-page {\n    --hmi-bg: #F5F7FB;\n    --hmi-card: #FFFFFF;\n    --hmi-accent: #2563EB;\n    --hmi-accent-ink: #FFFFFF;\n    --hmi-text: #0F172A;\n    --hmi-muted: #475569;\n    --hmi-hover: #EEF4FF;\n    --hmi-border: #E2E8F0;\n    --hmi-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 10px 28px rgba(15, 23, 42, 0.05);\n    --hmi-row: #F8FAFC;\n    --hmi-good: #047857;\n    --hmi-good-bg: #ECFDF5;\n    --hmi-warn: #B45309;\n    --hmi-warn-bg: #FFFBEB;\n    --hmi-danger: #B91C1C;\n    --hmi-danger-bg: #FEF2F2;\n    --hmi-input: #FFFFFF;\n    color-scheme: light;\n    box-sizing: border-box;\n    min-height: calc(100vh - 64px);\n    padding: 28px 32px 40px;\n    background: var(--hmi-bg);\n    color: var(--hmi-text);\n    font-family: \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n}\n\n.server-page[data-theme=\"dark\"] {\n    --hmi-bg: #0B1220;\n    --hmi-card: #172033;\n    --hmi-accent: #38BDF8;\n    --hmi-accent-ink: #082033;\n    --hmi-text: #F1F5F9;\n    --hmi-muted: #CBD5E1;\n    --hmi-hover: #1E293B;\n    --hmi-border: #334155;\n    --hmi-shadow: 0 1px 2px rgba(0, 0, 0, 0.28), 0 12px 32px rgba(0, 0, 0, 0.22);\n    --hmi-row: #121A2B;\n    --hmi-good: #34D399;\n    --hmi-good-bg: rgba(52, 211, 153, 0.12);\n    --hmi-warn: #FBBF24;\n    --hmi-warn-bg: rgba(251, 191, 36, 0.12);\n    --hmi-danger: #FCA5A5;\n    --hmi-danger-bg: rgba(248, 113, 113, 0.12);\n    --hmi-input: #0F172A;\n    color-scheme: dark;\n}\n\n.server-page--embedded {\n    min-height: 0;\n    padding: 0;\n    overflow: visible;\n    background: transparent;\n    font-family: inherit;\n}\n\n.server-page--embedded .server-page__card {\n    margin: 16px 18px;\n    box-shadow: none;\n}\n\n.server-page *,\n.server-page *::before,\n.server-page *::after {\n    box-sizing: border-box;\n}\n\n.server-page h1,\n.server-page h2,\n.server-page h3,\n.server-page p {\n    margin: 0;\n    color: var(--hmi-text);\n}\n\n.server-page__top {\n    margin-bottom: 22px;\n}\n\n.server-page__eyebrow {\n    margin-bottom: 6px;\n    color: var(--hmi-accent);\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n.server-page h1 {\n    font-size: 32px;\n    line-height: 1.15;\n    font-weight: 700;\n    letter-spacing: -0.03em;\n}\n\n.server-page__subtitle {\n    margin-top: 6px;\n    color: var(--hmi-muted);\n    font-size: 15px;\n}\n\n.server-page__card {\n    margin-bottom: 18px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 18px;\n    background: var(--hmi-card);\n    box-shadow: var(--hmi-shadow);\n}\n\n.server-page__card-head {\n    padding: 18px 18px 0;\n}\n\n.server-page__card-head h2,\n.server-page__item h3 {\n    font-size: 18px;\n    letter-spacing: -0.02em;\n}\n\n.server-page__card-head p {\n    margin-top: 4px;\n    color: var(--hmi-muted);\n    font-size: 13px;\n}\n\n.server-page__form,\n.server-page__banner,\n.server-page__test,\n.server-page__empty {\n    margin: 16px 18px;\n}\n\n.server-page__grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 14px;\n}\n\n.server-page__field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.server-page__field--wide {\n    grid-column: 1 / -1;\n}\n\n.server-page__field label {\n    color: var(--hmi-muted);\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n}\n\n.server-page__field input,\n.server-page__field select,\n.server-page__field textarea {\n    width: 100%;\n    max-width: none;\n    margin: 0;\n    padding: 10px 12px;\n    border: 1px solid var(--hmi-border);\n    border-radius: 10px;\n    background: var(--hmi-input);\n    color: var(--hmi-text);\n    font: inherit;\n    font-size: 14px;\n}\n\n.server-page__field input,\n.server-page__field select {\n    height: 40px;\n    padding-top: 0;\n    padding-bottom: 0;\n}\n\n.server-page__field textarea {\n    min-height: 96px;\n    resize: vertical;\n}\n\n.server-page__field input:focus-visible,\n.server-page__field select:focus-visible,\n.server-page__field textarea:focus-visible,\n.server-page__button:focus-visible {\n    outline: 2px solid var(--hmi-accent);\n    outline-offset: 2px;\n}\n\n.server-page__actions,\n.server-page__test {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 12px;\n}\n\n.server-page__test {\n    padding-bottom: 18px;\n}\n\n.server-page__button {\n    min-height: 40px;\n    margin: 0;\n    padding: 10px 16px;\n    border: 1px solid var(--hmi-accent);\n    border-radius: 12px;\n    background: var(--hmi-card);\n    color: var(--hmi-accent);\n    font: inherit;\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n    box-shadow: var(--hmi-shadow);\n}\n\n.server-page__button--primary {\n    background: var(--hmi-accent);\n    color: var(--hmi-accent-ink);\n}\n\n.server-page__button:hover,\n.server-page__button:focus-visible {\n    background: var(--hmi-accent);\n    color: var(--hmi-accent-ink);\n}\n\n.server-page__button:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n\n.server-page__banner {\n    flex: 1 1 280px;\n    padding: 12px 14px;\n    border-radius: 12px;\n    border: 1px solid var(--hmi-border);\n    background: var(--hmi-row);\n    color: var(--hmi-text);\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.server-page__banner.is-success {\n    color: var(--hmi-good);\n    background: var(--hmi-good-bg);\n    border-color: transparent;\n}\n\n.server-page__banner.is-error {\n    color: var(--hmi-danger);\n    background: var(--hmi-danger-bg);\n    border-color: transparent;\n}\n\n.server-page__banner.is-pending {\n    color: var(--hmi-warn);\n    background: var(--hmi-warn-bg);\n    border-color: transparent;\n}\n\n.server-page__empty {\n    padding: 8px 0 28px;\n    color: var(--hmi-muted);\n    text-align: center;\n    font-size: 14px;\n}\n\n.server-page__list {\n    list-style: none;\n    margin: 16px 0 0;\n    padding: 0;\n}\n\n.server-page__item {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 18px;\n    padding: 16px 18px;\n    border-top: 1px solid var(--hmi-border);\n}\n\n.server-page__item:hover {\n    background: var(--hmi-hover);\n}\n\n.server-page__endpoint {\n    margin-top: 4px;\n    color: var(--hmi-text);\n    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n    font-size: 13px;\n}\n\n.server-page__description {\n    max-width: 460px;\n    color: var(--hmi-muted);\n    font-size: 14px;\n    line-height: 1.45;\n    text-align: right;\n}\n\n.server-page__edit { width: 100%; }\n.server-page__summary { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; }\n.server-page__state { padding: 4px 9px; border-radius: 999px; background: rgba(4, 120, 87, .12); color: #047857; font-size: 12px; font-weight: 700; }\n.server-page__state.is-archived { background: var(--hmi-danger-bg); color: var(--hmi-danger); }\n.server-page__expiry { color: var(--hmi-muted); font-size: 13px; white-space: nowrap; }\n.server-page__row-actions { display: flex; gap: 8px; }\n.server-page__row-actions .server-page__button { width: auto; padding: 8px 12px; }\n.server-page__button--danger { border-color: var(--hmi-danger); color: var(--hmi-danger); }\n.server-page__field small { color: var(--hmi-muted); font-size: 12px; }\n.server-page__table-wrap { width: 100%; margin-top: 16px; overflow-x: auto; }\n.server-page__archive-table { width: 100%; border-collapse: collapse; color: var(--hmi-text); }\n.server-page__archive-table th,\n.server-page__archive-table td { padding: 12px 14px; border-bottom: 1px solid var(--hmi-border); text-align: left; vertical-align: middle; }\n.server-page__archive-table th { background: var(--hmi-hover); color: var(--hmi-muted); font-size: 12px; font-weight: 700; text-transform: uppercase; }\n.server-page__archive-table .server-page__endpoint { margin: 0; }\n.server-page__servers-table { min-width: 950px; font-size: 13px; }\n.server-page__archive-table tbody tr:nth-child(even) { background: var(--hmi-row); }\n.server-page__archive-table tbody tr:hover { background: var(--hmi-hover); }\n.server-page__health, .server-page__last-error { display: flex; flex-direction: column; align-items: flex-start; gap: 5px; }\n.server-page__connection { display: inline-flex; align-items: center; gap: 6px; padding: 4px 9px; border-radius: 999px; font-size: 12px; font-weight: 700; white-space: nowrap; }\n.server-page__connection::before { content: \"\"; width: 7px; height: 7px; border-radius: 50%; background: currentColor; }\n.server-page__connection.is-online { color: var(--hmi-good); background: var(--hmi-good-bg); }\n.server-page__connection.is-offline { color: var(--hmi-danger); background: var(--hmi-danger-bg); }\n.server-page__connection.is-unknown { color: var(--hmi-warn); background: var(--hmi-warn-bg); }\n.server-page__health small, .server-page__last-error small, .server-page__no-error, .server-page__table-description { color: var(--hmi-muted); font-size: 11px; }\n.server-page__table-description { display: block; margin-top: 4px; max-width: 180px; overflow-wrap: anywhere; }\n.server-page__last-error { min-width: 200px; max-width: 370px; font-size: 12px; overflow-wrap: anywhere; }\n.server-page__last-error code { color: var(--hmi-danger); font-size: 11px; }\n\n@media (max-width: 900px) {\n    .server-page__grid,\n    .server-page__item {\n        grid-template-columns: 1fr;\n        flex-direction: column;\n    }\n\n    .server-page__description {\n        max-width: none;\n        text-align: left;\n    }\n\n    .server-page__expiry { white-space: normal; }\n}\n\n@media (max-width: 800px) {\n    .server-page {\n        padding: 18px 14px 28px;\n    }\n\n    .server-page--embedded {\n        padding: 0;\n    }\n\n    .server-page h1 {\n        font-size: 26px;\n    }\n\n    .server-page__button {\n        width: 100%;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .server-page__button {\n        transition: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
